import '../style/App.css';
import Header from "./Header.jsx";
import Opzioni from "./Opzioni"
import "../style/prodottiPerTelefono.css";
import "../style/prodotti.css";
import "../style/popUp.css"

import Footer from "./Footer";

function App() {
  return (
    <div className='tuttoIndex'>
      <Header />
      <Opzioni />
      <Footer/>
    </div>
  );
}

export default App;
